import React from "react";
import { useQuery } from "@apollo/client";
import styled from "styled-components";
import { Table, Row, Button, Col, notification } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  NumberParam,
  useQueryParam,
  withDefault,
} from "use-query-params";

import { LIMIT_PAGE } from "constants/index";

import { USERS_QUERY } from "./employeesQueries";
import { EMPLOYEE_COLUMNS } from "./constants";

const Container = styled.div`
  padding: 12px;
`;

const StyledRow = styled(Row)`
  padding-bottom: 12px;
`;

const FlexCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

const Employees = ({ history }) => {
  const { t } = useTranslation();
  const [page, setPage] = useQueryParam("page", withDefault(NumberParam, 1));
  const { data, loading } = useQuery(USERS_QUERY, {
    onError: notification.error,
    fetchPolicy: "cache-and-network",
  });

  return (
    <Container>
      <StyledRow type="flex" justify="end">
        <FlexCol span={4}>
          <Button
            type="primary"
            onClick={() => history.push("/access/employees/new")}
          >
            {t("Add")}
          </Button>
        </FlexCol>
      </StyledRow>
      <Table
        rowKey="id"
        pagination={{
          current: page,
          onChange: setPage,
          pageSize: LIMIT_PAGE,
        }}
        loading={loading}
        columns={EMPLOYEE_COLUMNS}
        dataSource={data && data.users}
      />
    </Container>
  );
};

Employees.propTypes = {
  history: PropTypes.object.isRequired,
};

export default Employees;
